module.exports = __webpack_public_path__ + "img/9.1c86698b.jpg";